import React from 'react';
import RichTextEditor from './RichTextEditor';

interface HTMLRichTextEditorProps {
    HTMLValue?: string;
    onChange: (htmlValue: string) => void;
    customHeight?: object;
    simple?: boolean; // Add simple mode option
}

const HTMLRichTextEditor = React.memo<HTMLRichTextEditorProps>(({
    HTMLValue,
    onChange,
    customHeight = {},
    simple = false,
}) => {
    const handleChange = (htmlContent: string): void => {
        onChange(htmlContent);
    };

    return (
        <RichTextEditor 
            {...(HTMLValue !== undefined ? {value: HTMLValue} : {initialValue: ''})}
            onChange={handleChange} 
            customHeight={customHeight}
            simple={simple}
        />
    );
});

export default HTMLRichTextEditor;